import clsx from 'clsx';
import styles from './catalog-voucher-banner.module.scss';

const CatalogVoucherBanner = ({ text }: { text: string }) => {
  return (
    <div className={clsx(styles.catalogVoucherBanner, 'vc-banner__container')}>
      <div className={styles.catalogVoucherBanner__text}>{text}</div>
    </div>
  );
};

export default CatalogVoucherBanner;
